import { Model } from "pinia-orm";
import { CertipersUser } from "@/models";
import { AgencyGroup } from "@/models/socio-model";

export default class Agency extends Model {
  static name = "Agency";
  static entity = "agencies";

  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(""),
      code: this.string(""),
      name: this.string(""),
      address: this.string(""),
      city: this.string(""),
      country: this.string(""),
      postalCode: this.string(""),
      agencyGroup: this.attr(null), // Foreign key
      telephoneNumber: this.string(""),
      agencyGroupDatas: this.belongsTo(AgencyGroup, "agencyGroup"),
      user: this.hasMany(CertipersUser, "agency"),
    };
  }
}
